export const osnNoFoundIcon = {
  data: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M39.2013 42.0296C39.9824 42.8107 41.2487 42.8107 42.0298 42.0296C42.8108 41.2486 42.8108 39.9823 42.0298
 39.2012L39.2013 42.0296ZM29.9706 32.7989L39.2013 42.0296L42.0298 39.2012L32.799 29.9704L29.9706 32.7989Z" fill="white"/>
 <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 21C7.5 13.5442 13.5442 7.5 21 7.5C23.8422 7.5 26.4752 8.37668
 28.649 9.87432C29.3246 10.3398 29.9557 10.8651 30.5344 11.4424L32.6556 9.32124C31.9479 8.61493 31.1766 7.97267 30.351
  7.40389C27.6927 5.57241 24.4693 4.5 21 4.5C11.8873 4.5 4.5 11.8873 4.5 21C4.5 24.233 5.43134 27.253 7.04096 29.8011C7.69457 30.8358
   8.46036 31.793 9.32126 32.6555L11.4424 30.5345C10.7386 29.829 10.1123 29.0458 9.57729 28.1989C8.26163 26.1162 7.5 23.6493
   7.5 21ZM18.248 34.2194L15.8028 36.6646C17.4367 37.2065 19.184 37.5 21 37.5C30.1127 37.5 37.5 30.1127 37.5 21C37.5 19.1841
   37.2065 17.4367 36.6646 15.8028L34.2194 18.248C34.4034 19.1365 34.5 20.057 34.5 21C34.5 28.4558 28.4558 34.5 21 34.5C20.057
   34.5 19.1366 34.4034 18.248 34.2194Z" fill="white"/><path
   d="M40.231 7L7.00019 40.2308" stroke="#FF00D3" stroke-width="4" stroke-linecap="round"/>
   </svg>`,
  name: 'no-found',
};
